/* eslint-disable no-template-curly-in-string */
/* eslint-disable max-len */
import _template from 'lodash/template';

export const VALIDATION_MESSAGES = {
  getTemplatedValidation: (validationMessage, valueToBeInserted) => {
    const compiled = _template(validationMessage);
    return compiled(valueToBeInserted);
  },
  GENERIC: {
    ANSWER_LENGTH_GT_MAX: 'Your answer should be ${maxLength} characters or less',
    ANSWER_LENGTH_LT_MIN: 'Your answer should be ${minLength} characters or more',
    MISSING_ANSWER: '${fieldName} cannot be left blank',
  },
  DATE: {
    INVALID: 'Please enter a valid date to proceed',
  },
  PRIVACY_DISCLAIMER: 'To continue, you must read and agree to the privacy notice and consent to the terms',
  SESSION_TIMEOUT: 'Your ${journeyType} has been restarted as your session was inactive for more than 30 minutes.',
  BLOODPRESSURE: {
    READING_HIGH: 'This reading is dangerously high. You should repeat it as soon as possible. If your systolic blood pressure stays above 180 or your diastolic blood pressure stays above 120, urgently contact your surgery for advice.',
    READING_LOW: 'This reading is dangerously low. You should repeat it as soon as possible. If your systolic blood pressure stays below 80 or your diastolic blood pressure stays below 50, urgently contact your surgery for advice.',
    READING_REVERSED: 'You entered a systolic blood pressure that\'s lower than the diastolic blood pressure. Check to make sure the numbers are not the wrong way around.',
  },
  BMI: {
    WEIGHT: {
      OUT_OF_RANGE: {
        METRIC: 'Please enter a weight between 2kg and 318kg',
        IMPERIAL: 'Please enter a weight between 0st 4lb and 50st 1lb',
      },
      MISSING_VALUE: {
        IMPERIAL: {
          FIRST_PERSON: 'Please enter your weight in both stone and pounds',
          THIRD_PERSON: 'Please enter your child\'s weight in both stone and pounds',
        },
      },
      INVALID_VALUE: {
        IMPERIAL: {
          FIRST_PERSON: 'For the second part of your weight, please enter 13 pounds or less',
          THIRD_PERSON: 'For the second part of your child\'s weight, please enter 13 pounds or less',
        },
      },
    },
    HEIGHT: {
      OUT_OF_RANGE: {
        METRIC: 'Please enter a height between 5cm and 239m',
        IMPERIAL: 'Please enter a height between 0ft 2in and 7ft 10in',
      },
      MISSING_VALUE: {
        IMPERIAL: {
          FIRST_PERSON: 'Please enter your height in both feet and inches',
          THIRD_PERSON: 'Please enter your child\'s height in both feet and inches',
        },
      },
      INVALID_VALUE: {
        IMPERIAL: {
          FIRST_PERSON: 'For the second part of your height, please enter 11 inches or less',
          THIRD_PERSON: 'For the second part of your child\'s height, please enter 11 inches or less',
        },
      },
    },
  },
  PHOTO: {
    MAX_SIZE_EXCEEDED: 'Selected image is too large. The maximum size allowed is 8MB.',
    GENERIC: 'Something went wrong reading the file',
    MISSING_DESCRIPTION: 'Please add a description of the photo',
    FILE_EXTENSION_ERROR: 'Selected file is an invalid type. Files must be .jpeg or .png type.',
    MAX_PHOTOS_EXCEEDED: 'You can upload ${maxPhoto} photos. To upload a different photo, delete one of the selections above.',
  },
  HEIGHT: {
    INVALID_FORMAT: 'Please enter a valid height. Use one of these formats: 180cm, 1m 85cm, 5ft 10in or 5\' 10"',
  },
  WEIGHT: {
    INVALID_FORMAT: 'Please enter a valid weight. Use one of these formats: 82kg, 13st 4lb or 128lb',
  },
  CONNECTIVITY: {
    RECONNECTED: 'Internet connection is back. You can continue your booking.',
  },
  SEARCH: {
    MISSING_VALUE: 'Please search using the box below and select a result from the list',
  },
};
